/**
 * lorikeetSpectrumViewer_Constants.ts
 *
 * Javascript for  page lorikeetSpectrumViewerView.jsp
 *
 * Lorikeet Spectrum Viewer on it's own page
 *
 * Constants
 *
 */


export class LorikeetSpectrumViewer_Constants {

    static readonly OPENMOD_POSITION_QUERY_STRING_VALUE__N = "n";
    static readonly OPENMOD_POSITION_QUERY_STRING_VALUE__C = "c";

    static readonly OPENMOD_POSITION__NO_POSITION_SELECTED: string | number = null;
}